/* eslint-disable react/prop-types */
import React, { forwardRef, lazy, memo, Suspense, useMemo } from "react";
import { Box, CardContent } from "@mui/material";
import CourseCardContent from "./CourseCardContent";
import CourseCardFooter from "./CourseCardFooter";
import Loader from "../../Loader";
import LastDateToApply from "./LastDateToApply";
const LazyCardMedia = lazy(() => import("../../LazyCardMedia"));
const CourseCard = forwardRef((props, ref) => {
  const {
    customfontsize,
    isListView,
    itemwidthpx,
    image,
    courseCategory,
    courseHref,
    lastDate,
    courseTitle,
    instructorHref,
    instructorName,
    price,
    rating,
  } = props;

  const padding = 10;

  // Calculate updateWidth using useMemo
  const updatewidth = useMemo(() => {
    return itemwidthpx - 2 * padding;
  }, [itemwidthpx, padding]);

  // Calculate widthCurrent using useMemo and updateWidth
  const widthcurrent = useMemo(() => {
    return isListView ? `calc(100%)` : `${itemwidthpx}px`;
  }, [isListView, updatewidth, padding]);

  return (
    <Box
      ref={ref} // Attach the forwarded ref here
      style={{
        position: "relative",
        boxSizing: "border-box",
      }}
      sx={{
        width: widthcurrent,
        height: "100%",
        overflow: "hidden",
        margin: isListView ? "0px 10px" : "0px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        border: "1px solid white",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box
        style={{
          position: "relative",
          padding: `${padding}px`,
          boxSizing: "border-box",
          overflow: "hidden",
        }}
        sx={{
          display: isListView ? "flex" : "block",
          width: widthcurrent,
          ...(isListView && {
            justifyContent: "center",
            alignItems: "center",
          }),

          height: "100%",
        }}
      >
        {/* Image Section */}
        <Box
          style={{
            width: `${updatewidth * 0.8}px`,
            boxSizing: "border-box",
            height: `${updatewidth * 0.8}px`,
            display: "flex",
            overflow: "hidden",

            justifyContent: "center",
            alignItems: "center",
          }}
          sx={{
            m: "auto",
          }}
        >
          <Suspense
            fallback={<Loader text={`${courseTitle} - image is loading`} />}
          >
            <LazyCardMedia imgSrc={image} altText={courseTitle} />
          </Suspense>
        </Box>
        {/* Image Section */}

        {/* Content Section */}
        <CardContent
          style={{
            boxSizing: "border-box",
            width: "auto",
            margin: "0px",
            textAlign: "start",
            flex: 1,
            display: "flex",
            justifyContent: "start",
            alignItems: "start",
            flexDirection: "column",
          }}
          sx={{
            ...(!isListView
              ? { padding: "0px", paddingTop: `${padding}px` }
              : { padding: "0px", paddingLeft: `${padding}px` }),
          }}
        >
          <CourseCardContent
            courseTitle={courseTitle}
            courseCategory={courseCategory}
            rating={rating}
            instructorHref={instructorHref}
            instructorName={instructorName}
            customfontsize={customfontsize}
          />

          {/* Bottom Section */}
          <CourseCardFooter price={price} customfontsize={customfontsize} />
        </CardContent>

        {/* Content Section */}
      </Box>
      <LastDateToApply lastDate={lastDate} customfontsize={customfontsize} />
    </Box>
  );
});
export default memo(CourseCard);
